import { Expose, Transform } from 'class-transformer'

export class CategoryType {
  @Expose() id: number

  @Expose() name: string

  @Expose()
  @Transform(({ value }) => value || '')
  seoManga: string

  @Expose()
  @Transform(({ value }) => value || '')
  seoNovel: string

  @Expose() seoTitleNovel: string

  @Expose() seoDescriptionNovel: string

  @Expose() seoTitleManga: string

  @Expose() seoDescriptionManga: string
}
